module.exports = __webpack_public_path__ + "img/115.2e021606.jpg";